import { z } from 'zod'

/**
 * `PUT /admin/platform/brand` (TO-541 REQ-003) — SHAPE only: exactly `{ brandId }`
 * with a 1–64 character string, no other key (→ `VALIDATION_ERROR`). Whether the id
 * is a published catalogue brand is the service's `BRAND_NOT_SELECTABLE` rule.
 */
export const platformBrandSelectSchema = z.strictObject({ brandId: z.string().min(1).max(64) })

export type PlatformBrandSelectInput = z.infer<typeof platformBrandSelectSchema>
